export  enum  NotityType{
  Success='SUCCESS',
  Danger='DANGER'
}

